var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.23926 9.47852L25.6785 9.47852","stroke":"#1E2A67","strokeWidth":"4.85981","key":0}),React.createElement("path",{"d":"M6.23926 15.959L25.6785 15.959","stroke":"#1E2A67","strokeWidth":"4.85981","key":1}),React.createElement("path",{"d":"M6.23926 22.4395L25.6785 22.4395","stroke":"#1E2A67","strokeWidth":"4.85981","key":2})]);
}

MenuIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
